import { render, staticRenderFns } from "./single-training-show.vue?vue&type=template&id=6313488e&scoped=true"
import script from "./single-training-show.vue?vue&type=script&lang=js"
export * from "./single-training-show.vue?vue&type=script&lang=js"
import style0 from "./single-training-show.vue?vue&type=style&index=0&id=6313488e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6313488e",
  null
  
)

export default component.exports